import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { orderService } from "../Services/OrderService.js";
import * as orderActions from '../Actions/orderActions';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Redirect } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';

class UploadTranslatedDocument extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fileSelectd: 0,
			esXLIFF: 0,
			uploading: 0,
			message: '',
			document: ''
		};
		this.handleDocument = this.handleDocument.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSubmitFinish = this.handleSubmitFinish.bind(this);
	}
	
	handleDocument(e) {
		let extension = e.target.files[0].name.split('.').pop().toLowerCase();
		this.setState({fileSelectd: 1});
		this.setState({document: e.target.files[0]});
		if(extension=='xlf' || extension=='xlif' || extension=='xliff' || extension=='eclxliff'){
			this.setState({esXLIFF: 1});
		}else{
			this.setState({esXLIFF: 0});
		}
		//console.log("Extension: "+extension+" ["+this.state.esXLIFF+"]");
	}
	
	handleChange(e) {
		e.preventDefault();
		this.setState({message: e.target.value});
	}

	handleSubmit(e) {
		this.setState({uploading: 1});
		if(this.state.esXLIFF>0){
			orderService.uploadDocument(this.props.user.access_token, this.props.order.links.find(function(link){return link.rel=="TRANSLATION";}).href, this.state.document)
				.then(response => { return this.setState({uploading: 2});})
				.catch(err => {/*console.log(err);*/});
		}else{
			let phase=""
			switch(this.props.order.task){
				case "translation":		phase="TRANSLATION";	break;
				case "proof_print":		phase="PROOF_PRINTING";	break;
			}
			orderService.uploadDocument(this.props.user.access_token, this.props.order.links.find(function(link){return link.rel==phase;}).href, this.state.document)
				.then(response => { if(this.state.message.trim().length>0){
											orderService.sendMessage(this.props.order.id, this.state.message);
									}
									return 1;})
				.then(response => { return orderService.finishOrderTask(this.props.order.id, 0)})
				.then(response => { return this.setState({uploading: 2});})
				.catch(err => {/*console.log(err);*/});
		}
	}
	
	handleSubmitFinish(e) {
		this.setState({uploading: 1});
		let phase=""
		switch(this.props.order.task){
			case "translation":		phase="TRANSLATION";	break;
			case "proof_print":		phase="PROOF_PRINTING";	break;
		}
		orderService.uploadDocument(this.props.user.access_token, this.props.order.links.find(function(link){return link.rel==phase;}).href, this.state.document)
					.then(response => { return orderService.finishOrderTask(this.props.order.id, this.state.esXLIFF)})
					.then(response => { return this.setState({uploading: 2});})
					.catch(err => {/*console.log(err);*/});
	}
	
	render() {
		let button2="";
		let flagXLIFF="";
		const disabled = this.state.fileSelectd==0;
		if (this.state.uploading>0) {
			if (this.state.uploading>1) {
				return <Redirect to='/orderList'/>;
			}else{
				return <div className="content_centered">SENDING....</div>;
			}
		}
		if(this.state.esXLIFF>0 && this.state.fileSelectd>0){
			button2=<Grid item>
						<Button disabled={disabled} style={{fontFamily: "'Lato', sans-serif", fontSize: "12px", backgroundColor: "#dfdfdf"}} onClick={this.handleSubmitFinish} color="primary">
							Send and finalize
						</Button>
					</Grid>
			flagXLIFF =	<Grid item>
							<span className='esxliff'>XLIFF</span>
						</Grid>
		}
		return (
			<div class="contentM">
			<form>
			<Grid container item direction="column" alignItems="flex-start" justify="flex-start" spacing={2}>
				<Grid item>
					<h1 className="title">Upload translated Document</h1>
				</Grid>
				<Grid item container direction="row" alignItems="flex-start" justify="flex-start" spacing={2}>
					<Grid item>
						{this.props.order.code}
					</Grid>
					<Grid item>
						[{this.props.customerRecords.name}]
					</Grid>
				</Grid>
				<Grid item container direction="row" alignItems="center" justify="flex-start" spacing={2}>
					<Grid item>
						<Paper>
							<Button label="Choose file" component="span">
								<input type="file" name="docuemnt" style={{ overflow: 'hidden' }} onChange={this.handleDocument}/>
							</Button>
						</Paper>
					</Grid>
					<Grid item>
						{flagXLIFF}
					</Grid>
				</Grid>
				<Grid item xs={12}>Notes:</Grid>
				<Grid item xs={12}>
					<textarea
						onChange={this.handleChange}
						style={{width: "100%"}}
						rows="2"
						id="message"
						name="message"
						value={this.state.message}
					/>
				</Grid>
				<Grid item container direction="row" alignItems="flex-start" justify="flex-start" spacing={2}>
					<Grid item>
						<Button disabled={disabled} style={{fontFamily: "'Lato', sans-serif", fontSize: "12px", backgroundColor: "#dfdfdf"}} onClick={this.handleSubmit} color="primary">
							Send
						</Button>
					</Grid>
					{button2}
				</Grid>
			</Grid>
			</form>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {order: state.orders[ownProps.match.params.id], userRecords: state.users[state.orders[ownProps.match.params.id].user], customerRecords: state.customers[state.users[state.orders[ownProps.match.params.id].user].customer], user: state.user}
}
function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(orderActions, dispatch)}
}
export default connect(mapStateToProps, mapDispatchToProps)(UploadTranslatedDocument);  